import { cloneDeep, omit } from "lodash";

export const modifyCopyData = (data) => {
  const pdfData = cloneDeep(omit(data, "backupData"));
  pdfData.data = Object.keys(pdfData.data).reduce((acc, key) => {
    acc[key] = Object.keys(pdfData.data[key]).reduce((acc2, key2) => {
      acc2[key2] = { ...pdfData.data[key][key2], block_access: "active" };
      return acc2;
    }, {});
    return acc;
  }, {});

  return pdfData;
};

export const buildTrackingData = (store, visibilitySaveConfig) => {
  try {
    const { pdf, web } = visibilitySaveConfig;

    const pdfRawData = store.pdf.rawData;
    const webRawData = store.web.rawData;

    const updatePdf = {};
    const updateWeb = {};

    Object.keys(pdf ?? {}).forEach((key) => {
      const userRoleString = pdfRawData.review_cycle_user_roles.find(
        (role) => role.user_role_id === Number(key)
      )?.user_role_text;

      Object.keys(pdf[key] ?? {}).forEach((key2) => {
        const reviewerTypeString = pdfRawData.review_cycle_reviewer_types.find(
          (type) => type.reviewer_type_id === Number(key2)
        )?.reviewer_type_text;

        updatePdf[`${userRoleString} - ${reviewerTypeString}`] =
          pdf[key][key2].visibility;
      });
    });

    Object.keys(web ?? {}).forEach((key) => {
      const userRoleString = webRawData.review_cycle_user_roles.find(
        (role) => role.user_role_id === Number(key)
      )?.user_role_text;

      Object.keys(web[key] ?? {}).forEach((key2) => {
        const reviewerTypeString = webRawData.review_cycle_reviewer_types.find(
          (type) => type.reviewer_type_id === Number(key2)
        )?.reviewer_type_text;

        updateWeb[`${userRoleString} - ${reviewerTypeString}`] =
          web[key][key2].visibility;
      });
    });

    const data = {};

    if (Object.keys(updatePdf).length > 0) {
      data.updatePdf = JSON.stringify(updatePdf);
    }

    if (Object.keys(updateWeb).length > 0) {
      data.updateWeb = JSON.stringify(updateWeb);
    }

    return {
      ...data,
      isVisibilityCheckbox: visibilitySaveConfig.isVisibilityCheckbox,
    };
  } catch (error) {
    console.error(error);
  }
};
